var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.589 2.26022C7.78784 1.97321 8.21216 1.97321 8.411 2.26022L11.7864 7.13225C12.0162 7.46385 11.7789 7.91699 11.3754 7.91699H4.62456C4.22115 7.91699 3.98382 7.46385 4.21356 7.13224L7.589 2.26022Z",
    fill: "#D5DCE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3426 17.8387C8.17689 18.0778 7.8233 18.0778 7.6576 17.8387L4.12305 12.737C3.9316 12.4606 4.12937 12.083 4.46554 12.083L11.5347 12.083C11.8708 12.083 12.0686 12.4606 11.8772 12.737L8.3426 17.8387Z",
    fill: "#D5DCE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSort);
export default __webpack_public_path__ + "static/media/default-sort.f21ba0d86b86533614ac5b93bbf5e6dc.svg";
export { ForwardRef as ReactComponent };